// Mobile header: hide on scroll down, show on scroll up.
// Only applies below the mobile breakpoint. Toggles .header-sections--hidden.
(function () {
  var MOBILE_BREAKPOINT = 750;
  var SCROLL_THRESHOLD = 5; // px — ignore tiny jitter

  var headerSections = document.querySelector('.header-sections');
  if (!headerSections) return;

  var lastScrollY = window.scrollY;
  var ticking = false;

  function onScroll() {
    if (ticking) return;

    window.requestAnimationFrame(function () {
      // Only run on mobile
      if (window.innerWidth >= MOBILE_BREAKPOINT) {
        headerSections.classList.remove('header-sections--hidden');
        lastScrollY = window.scrollY;
        ticking = false;
        return;
      }

      var currentScrollY = window.scrollY;
      var delta = currentScrollY - lastScrollY;

      // Scrolling down past threshold → hide header
      if (delta > SCROLL_THRESHOLD && currentScrollY > headerSections.offsetHeight) {
        headerSections.classList.add('header-sections--hidden');
      }
      // Scrolling up past threshold → show header
      else if (delta < -SCROLL_THRESHOLD) {
        headerSections.classList.remove('header-sections--hidden');
      }

      // Always show at the very top of the page
      if (currentScrollY <= 0) {
        headerSections.classList.remove('header-sections--hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    });

    ticking = true;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();
